export default "__VITE_ASSET__ClheQytP__"